import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/shipping-rates")({
	component: ShippingRatesLayout,
})

function ShippingRatesLayout() {
	return <Outlet />
}
